import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year5/Summer/ConvertingUnits/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'ConvertingUnits',
  field: 'Measurement',
  weeks: [10, 11],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Summer/ConvertingUnits/1KilogramsAndKilometres" */ './1KilogramsAndKilometres'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Summer/ConvertingUnits/2MillimetresAndMillilitres" */ './2MillimetresAndMillilitres'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Summer/ConvertingUnits/3ConvertUnitsOfLength" */ './3ConvertUnitsOfLength'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Summer/ConvertingUnits/4ConvertBetweenMetricAndImperialUnits" */ './4ConvertBetweenMetricAndImperialUnits'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Summer/ConvertingUnits/5ConvertUnitsOfTime" */ './5ConvertUnitsOfTime'
        )
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Summer/ConvertingUnits/6CalculateWithTimetables" */ './6CalculateWithTimetables'
        )
    })
  ]
});
export default Block;
